module.exports = __webpack_public_path__ + "img/back_white.7ffce3fb.svg";